<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="SP"> </p>
<p class="Dedication-ded"><i>For the peerless JGs:</i></p>
<p class="Dedication-ded"><i>Jonny Geller and Jane Gelfman</i></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?662dea93